import { latlong2featurePoint } from '../geojson-utilities';
import drawLandingBearing from './drawLandingBearing';

/**
 * Gets the new end point for the landing bearing from the event fired (move end).
 * Saves it to database and re-draws the landing bearing.
 *
 * @callback
 * @param {*} arg - The object argument.
 * @param {object} arg.event - The event fired after creating a the landing bearing.
 * @param {Function} arg.getCurrentMapState - A function that gets the current variables needed from the map component.
 */
const setLandingBearing = ({ event, getCurrentMapState }) => {
  const { getAngleActive, updateLandingBearing } = getCurrentMapState();
  if (getAngleActive) {
    const toPoint = latlong2featurePoint(event.latlng.wrap());
    const newLandingBearing = drawLandingBearing({ toPoint, getCurrentMapState });
    updateLandingBearing(newLandingBearing);
  }
};

export default setLandingBearing;
